import { API_DOMAIN } from 'constants/infograph';
import { DesignGenerationType, ReplaceWidgetInfoType } from 'types/ai.types';
import { InfographState } from 'types/infographTypes';
import { TableData } from 'types/spreadsheet';
import request from 'utils/request';

const BASE_PATH = '/api/design';
const PUBLIC_PATH = `${API_DOMAIN}/public`;

interface UpdateDesignByPromptParams {
  designId: string;
  prompt: string;
  type: DesignGenerationType;
  replaceWidgetInfo?: ReplaceWidgetInfoType;
  tableData?: TableData;
  isPublic?: boolean;
}

type UpdateDesignByPromptResponse = {
  status: string;
  updatedInfographState: InfographState;
  searchKeywords: string[];
  chartType?: string;
};

/**
 * Update design by prompt
 * Note: Use E1 backend API so it uses the correct JWT token and have write permission
 * Note: When it is public, the backend is readonly and is directly calling the E2 backend API
 *
 * @param designId to update
 * @param prompt to update by
 * @returns {UpdateDesignByPromptResponse}
 */
export const updateDesignByPrompt = async ({
  designId,
  prompt,
  type,
  replaceWidgetInfo,
  tableData,
  isPublic,
}: UpdateDesignByPromptParams) =>
  await request<UpdateDesignByPromptResponse>(`${isPublic ? PUBLIC_PATH : BASE_PATH}/updateDesignByPrompt`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
    },
    body: JSON.stringify({
      designId,
      prompt,
      type,
      replaceWidgetInfo,
      tableData,
    }),
  });
